/**
 * Date-extensions locale Arabic (Tunisia) [ar-tn]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('ar-tn', {
    monthNames: ['جانفي','فيفري','مارس','أفريل','ماي','جوان','جويلية','أوت','سبتمبر','أكتوبر','نوفمبر','ديسمبر'],
    monthShortNames: ['جانفي','فيفري','مارس','أفريل','ماي','جوان','جويلية','أوت','سبتمبر','أكتوبر','نوفمبر','ديسمبر'],
    dayNames: ['الأحد','الإثنين','الثلاثاء','الأربعاء','الخميس','الجمعة','السبت'],
    dayShortNames: ['أحد','إثنين','ثلاثاء','أربعاء','خميس','جمعة','سبت']
});
